import React, {
  useEffect,
  useState
} from "react";


import {
  Box,
  Typography,
  CircularProgress
} from "@mui/material";


import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";


import {
  getResolutionTimeReport
} from "../../services/reportService";
import uiConfig from "../../config/uiConfig";






function ResolutionTimeChart({ departmentId = null }){



const [data,setData] = useState([]);

const [loading,setLoading] = useState(true);







useEffect(()=>{


const loadResolution = async()=>{


try{


const response = await getResolutionTimeReport(departmentId);




setData([

{

name:"Average",

hours:response.average_hours

}

]);



}

catch(error){


console.error(

"Resolution Time Error:",

error

);


}

finally{


setLoading(false);


}


};



loadResolution();


},[departmentId]);









if(loading){


return (

<Box

height="100%"

display="flex"

justifyContent="center"

alignItems="center"

>

<CircularProgress/>

</Box>

);


}









return(


<Box

height="100%"

>





<Typography

sx={{

fontSize:14,

fontWeight:600,

color:"text.primary",

mb:2

}}

>

Average Resolution Time

</Typography>









<ResponsiveContainer

width="100%"

height={250}

>


<BarChart

data={data}

barSize={40}

>





<CartesianGrid

strokeDasharray="3 3"

vertical={false}

/>







<XAxis

dataKey="name"

fontSize={12}

/>







<YAxis

fontSize={12}

label={{

value:"Hours",

angle:-90,

position:"insideLeft"

}}

/>







<Tooltip

formatter={(value)=>[

`${value} hrs`,

"Resolution Time"

]}

/>







<Bar

dataKey="hours"

fill={uiConfig.chartPrimaryColor}

radius={[6,6,0,0]}

/>






</BarChart>


</ResponsiveContainer>







</Box>


);


}



export default ResolutionTimeChart;